import { moment } from 'utils/web'

export const AddMeta = () => {

    const local = window.location.hostname === 'localhost'
    const doc: any = document ?? {}
    doc.title = "The Link | FMS"
    const low = doc.documentElement.clientWidth < 1024 ? '0.75' : '1'
    const meta = doc.createElement('meta')

    meta.name = "viewport"
    meta.content = `width=device-width, user-scalable=yes, initial-scale=1.0, maximum-scale=${low}, minimum-scale=${low}`
    doc.getElementsByTagName('head')[0].appendChild(meta)
    // if (local) doc.getElementsByTagName("body")[0].style = `filter: sepia(1)`

    const scripts = [
        `<script type="x-shader/x-vertex" id="vertexshader">
            attribute float size;
            varying vec3 vColor;
            void main() {
                vColor = color;
                vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
                gl_PointSize = size * ( 1.0 );
                gl_Position = projectionMatrix * mvPosition;
            }
        </script>`,
        `<script type="x-shader/x-fragment" id="fragmentshader">
            uniform sampler2D pointTexture;
            varying vec3 vColor;
            void main() {

                gl_FragColor = vec4( vColor, 1.0 );
                gl_FragColor = gl_FragColor * texture2D( pointTexture, gl_PointCoord );

            }
        </script>`
    ]

    scripts.map((s) => doc.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', s))

}

export class Persist {

    cbs: any = []

    constructor() {

        window.addEventListener("storage", (event) => this.notify(event.key, event.newValue))

    }

    set = (key: string, value: string | null) => {

        localStorage.setItem(key, value === null ? '' : value)
        this.notify(key, value)

    }

    get = (key: string) => {

        return localStorage.getItem(key)

    }

    notify = (key: string | null, value: string | null) => {

        this.cbs.map(([ki, cb]: any) => {
            try { ki === key && cb(value) } catch { }
        })

    }

    on = (key: string, cb: (value: string | null) => any) => {

        this.cbs.push([key, cb])

    }

}

export const parseLocation = (location: any) => {

    const e = {
        project: '',
        type: '',
        name: '',
        g1: { isrtk: '', sats: 0 },
        g2: { isrtk: '', sats: 0 },
        gps: [0, 0, 0],
        utm: [0, 0, 0],
        speed: 0,
        head: 0,
        accuracy: { _2d: 0, _3d: 0 },
        gsm: { state: '', perc: 0, operator: '' },
        val: { screen: 0, type: '', value: '' },
        rtcm: '',
        activity: '',
        tablet: 0,
        network_usage: ``,
        throttled: '',
        updatedAt: 0,
    }

    try {

        const { data } = location
        const [_g, _g1, _g2, _gps, _gsm, _rtcm, _val] = data.split('|')
        const g = _g.split(',')
        const g1 = _g1.split(',')
        const g2 = _g2.split(',')
        const gps = _gps.split(',')
        const gsm = _gsm.split(',')
        const [rtcm, activity, tablet] = _rtcm.split(',')
        const val = _val.split(',')

        e.g1.isrtk = g1[0]; e.g1.sats = Number(g1[1]);
        e.g2.isrtk = g2[0]; e.g2.sats = Number(g2[1]);
        e.accuracy._2d = Number(gps[0]); e.accuracy._3d = Number(gps[1]);
        e.gsm.state = gsm[0]; e.gsm.perc = Number(gsm[1]); e.gsm.operator = gsm[2];
        e.val.screen = Number(val[0] ?? 0); e.val.type = val[1], e.val.value = val[2];

        e.rtcm = rtcm
        e.activity = activity
        e.tablet = Number(tablet)

        e.gps = [Number(g[0]), Number(g[1]), 0]
        e.utm = [Number(location.east), Number(location.north), Number(location.elevation)]
        e.head = Number(location.heading)
        e.speed = Number(location.speed)

        e.project = location.proj
        e.type = location.type
        e.name = location.name
        e.throttled = gsm[5]
        e.network_usage = `RX: ${gsm[3]} kbps TX: ${gsm[4]} kbps`
        e.updatedAt = moment(location.updatedAt).valueOf()

        return e

    } catch (err) { return e }

}

export const DXF_GeoJson_Parser = (data: { features: any[] }) => {

    const { features } = data

    const points: tItem[] = []
    const polygons: tItem[] = []
    const linestrings: tItem[] = []

    for (const x of features) {

        const { geometry, properties } = x
        const { type, coordinates } = geometry

        type === 'LineString' && linestrings.push({ ...properties, Coords: coordinates })
        type === 'Polygon' && polygons.push({ ...properties, Coords: coordinates })
        type === 'Point' && points.push({ ...properties, Coords: coordinates })

    }

    return {
        points,
        polygons,
        linestrings,
    }

}

export const CSV_GeoJson_Parser = (data: { features: any[] }): csvItems[] => {

    try {

        const { features } = data

        return features.map((e: any) => {
            const { field_1, field_2, field_3, field_4, field_5 } = e.properties
            return [field_1, Number(field_3), Number(field_2), Number(field_4), Number(field_5), undefined]
        })

    } catch (err) {
        return []
    }


}

export const findBoundaryPoints = (data: csvItems[]) => {
    const points = data.map(row => ({
        label: row[0],
        x: row[1],
        y: row[2],
        z: row[3]
    }))

    return {
        minX: points.reduce((a, b) => b.x < a.x ? b : a),
        maxX: points.reduce((a, b) => b.x > a.x ? b : a),
        minY: points.reduce((a, b) => b.y < a.y ? b : a),
        maxY: points.reduce((a, b) => b.y > a.y ? b : a),
        minZ: points.reduce((a, b) => b.z < a.z ? b : a),
        maxZ: points.reduce((a, b) => b.z > a.z ? b : a)
    }
}

export const expandBoundingBox = (data: csvItems[], n: number): [number, number, number][] => {

    const { minX, maxX, minY, maxY, minZ, maxZ } = findBoundaryPoints(data)

    const x0 = minX.x - n, x1 = maxX.x + n, xm = (minX.x + maxX.x) / 2
    const y0 = minY.y - n, y1 = maxY.y + n, ym = (minY.y + maxY.y) / 2
    const z0 = minZ.z, z1 = maxZ.z

    return [
        [x0, y0, z0],  // bottom-left
        [xm, y0, z0],  // bottom-mid
        [x1, y0, z0],  // bottom-right
        [x1, ym, z0],  // right-mid
        [x1, y1, z1],  // top-right
        [xm, y1, z1],  // top-mid
        [x0, y1, z1],  // top-left
        [x0, ym, z1],  // left-mid
    ]
}